import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as T_T from 'cryface';

@Component
export default class PropertyCost extends Vue {
   public title: string = 'PropertyCost';

   @Prop()
   public data: any;

   public displayData: any = {
      firstPay: '',
      theFirstTax: '',
      totalPay: '',
      notTheFirstTax: '',
      monthPay: ''
   };

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         this.displayData = val;
      }
   }
}
